import { NavigationIndex } from 'libs/pages/room-offer/src/lib/types'
import { getOfferIndex } from 'libs/pages/room-offer/src/lib/utils'
import { immer } from 'zustand/middleware/immer'
import { createWithEqualityFn as create } from 'zustand/traditional'

import { Offer, OffersAndMetadata } from '@wwt/entities/search-response'

import { replaceOfferInPages } from '@/entities/offer/utils/replaceOfferInPages'
import { createSelectors } from '@/shared/lib/createSelectors.ts'

import { checkOfferExistsInPages } from './helpers'

export type State = {
	pages: OffersAndMetadata[]
	selectedId: string | null

	// TODO: Refactor DTO
	selectedIndex: NavigationIndex | null
}

export type Actions = {
	setSelectedId: (offerId: string) => void
	setPages: (newPages: OffersAndMetadata[]) => void

	/**
	 * Method for overwrite offer info
	 */
	updateOfferInfo: (offerId: string, newOffer: Offer) => void
}

/**
 * Q: Do we actually need this?
 * We can just get value from react-query, no?
 *
 * TODO: FE-2370
 */
export const useSearchResponseStoreBase = create<State & Actions>()(
	immer(set => ({
		pages: [],
		selectedId: null,
		selectedIndex: null,

		setSelectedId: newSelectedId => {
			set(state => {
				const isOfferExists = checkOfferExistsInPages(
					state.pages,
					newSelectedId
				)

				if (!isOfferExists) {
					throw new Error(`Offer with id ${newSelectedId} not found`)
				}

				state.selectedId = newSelectedId
				state.selectedIndex = getOfferIndex(newSelectedId, state.pages)
			})
		},

		setPages: newPages => {
			set(state => {
				const isOfferExists = state.selectedId
					? checkOfferExistsInPages(newPages, state.selectedId)
					: false

				state.pages = newPages

				if (isOfferExists) return

				if (
					newPages.length !== 0 &&
					newPages[0].offers.length !== 0 &&
					newPages[0].offers[0].IDs.nonPersistingOfferId !== undefined
				) {
					const offerId = newPages[0].offers[0].IDs.nonPersistingOfferId
					state.selectedId = offerId
					state.selectedIndex = getOfferIndex(offerId, newPages)
					return
				}

				state.selectedId = null
				state.selectedIndex = null
			})
		},

		updateOfferInfo: (offerId: string, newOffer: Offer) => {
			set(state => {
				state.pages = replaceOfferInPages(state.pages, offerId, newOffer)
			})
		}
	}))
)

export const useSearchResponseStore = createSelectors(
	useSearchResponseStoreBase
)
